import CloseIcon from '@mui/icons-material/Close';
import { Box, Divider, Modal, TextField, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { useMutation } from 'react-query';
import image from '../../../images/cane_front_panel.png';
import useStore from '../../../Store/Store';
import { pairDeviceApi, pairRecipientDeviceApi } from '../../../utils/api';
import Button from '../../../components/Button';
import IconButton from '../../../components/IconButton';

const AddDeviceModal = ({ show, onClose, refetch, recipient = null, cr = false, refetchRecipient }) => {
  const user = useStore((state) => state.user);
  const [state, setState] = useState({
    pin: '',
    errorMessage: '',
  });

  const pairDevicehandler = useMutation(pairDeviceApi, {
    onSuccess: async ({ data }) => {
      refetch();
      onClose();
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setState((prev) => {
        return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
      });
    },
  });

  const pairRecipientDevicehandler = useMutation(pairRecipientDeviceApi, {
    onSuccess: async ({ data }) => {
      refetchRecipient();
      onClose();
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setState((prev) => {
        return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
      });
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isEmpty(state.pin)) {
      setState((prev) => {
        return { ...prev, errorMessage: 'Pin cannot be empty' };
      });
      return;
    }

    if (cr) {
      pairRecipientDevicehandler.mutate({ userId: user?._id, recipientId: recipient?._id, pin: state.pin });
    } else {
      pairDevicehandler.mutate({ userId: user?._id, pin: state.pin });
    }
  };

  return (
    <Modal open={show} onClose={onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '30%',
          p: 6,
          bgcolor: 'background.paper',
          borderRadius: 2.5,
          position: 'relative',
          top: 30,
          left: '35%',
        }}
      >
        <IconButton
          style={{
            position: 'absolute',
            top: 6,
            right: 6,
          }}
          onClick={onClose}
        />

        {/* <Typography
          variant="h5"
          sx={{
            fontWeight: 500,
            color: '#333333',
          }}
        >
          Connect CAN Go
        </Typography> */}

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
              padding: 8,
              backgroundColor: '#F5F5F5',
              borderRadius: 2,
              overflow: 'hidden',
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 500,
                color: '#333333',
              }}
            >
              Activate your CAN Go
            </Typography>

            <Typography
              variant="body4"
              sx={{
                textAlign: 'center',
                color: '#757575',
              }}
            >
              Press and hold the middle button for 10 seconds to display your CAN Go PIN number, then enter it below.
            </Typography>

            <Box
              component="img"
              sx={{
                width: 'auto',
                height: 184,
                marginBottom: -3,
              }}
              alt="Image"
              src={image}
            />
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              width: '100%',
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: '#757575',
              }}
            >
              Enter PIN here
            </Typography>

            <TextField
              fullWidth
              placeholder="PIN"
              variant="outlined"
              sx={{
                borderRadius: '50px',
                '& .MuiOutlinedInput-root': {
                  borderRadius: '50px',
                },
              }}
              onChange={(e) =>
                setState((prev) => {
                  return { ...prev, pin: e.target.value };
                })
              }
              value={state.pin}
            />
          </Box>
        </Box>

        <Divider
          sx={{
            marginTop: 2,
            borderColor: '#E0E0E0',
          }}
        />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: 2,
          }}
        >
          <Button text="Cancel" onClick={onClose} bg="light" />
          <Button text="Pair" onClick={handleSubmit} loading={pairDevicehandler.isLoading} />
        </Box>
        <Typography variant="subtitle1" style={{ color: 'red', marginTop: '30px' }} textAlign="center">
          {state.errorMessage}
        </Typography>
      </Box>
    </Modal>
  );
};

export default AddDeviceModal;
